var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/informationrequest/viewmodels/spousePartnerInfo',["require", "exports", "plugins/dialog", "common/viewmodelbase", "areas/informationrequest/models/bindable"], function (require, exports, dialog, common, VM) {
    "use strict";
    var SpouseInfoViewModel = (function (_super) {
        __extends(SpouseInfoViewModel, _super);
        function SpouseInfoViewModel() {
            _super.call(this);
            this.spouseInfo = new VM.SpouseInfo();
        }
        SpouseInfoViewModel.prototype.onActivated = function (context) {
            this.dontShow = false;
            this.spouseInfo = context.callingParameters.get("unknown");
            if (this.spouseInfo.dom != "-") {
                var date = new Date(Date.parse(this.spouseInfo.dom.toString()));
                this.doMString = date.toLocaleDateString('en-GB');
            }
            else
                this.doMString = "-";
            if (this.spouseInfo.spouseDOB != "-") {
                date = new Date(Date.parse(this.spouseInfo.spouseDOB.toString()));
                this.dobString = date.toLocaleDateString('en-GB');
            }
            else
                this.dobString = "-";
            if (this.spouseInfo.spouseNINO != "-") {
                this.ninoString = this.spouseInfo.spouseNINO.replace(/(.{2})/g, "$1 ");
            }
            else
                this.ninoString = "-";
        };
        SpouseInfoViewModel.prototype.closeDialog = function () {
            dialog.close(this);
        };
        return SpouseInfoViewModel;
    }(common.ListViewModelBase));
    var instance = new SpouseInfoViewModel();
    return instance;
});

